import LoanHelpers from './LoanHelpers'
import NumberHelpers from './NumberHelpers'
import ArrayHelpers from './ArrayHelpers'
import StringHelpers from './StringHelpers'
import SelectionHelpers from './SelectionHelpers'
import Store from '../store/Store'
//import DataHelpers from './DataHelpers';
import FireData from '../data/FireData';
import ContactHelpers from './ContactHelpers';
import DataHelpers from './DataHelpers';
import NiceData from '../data/NiceData';
//import { constants } from 'fs';



export default class {

    static loanAttributes() {
        let attributes = []
        if(this.getValueFromName('purchase'))
            attributes.push('Purchase')
        if(this.getValueFromName('first_home'))
            attributes.push('First Home')
        if(this.getValueFromName('refinance'))
            attributes.push('Refinance')
        if(this.getValueFromName('guarantor'))
            attributes.push('Guarantor')
        if(this.getValueFromName('preapproval'))
            attributes.push('Preapproval')
        return StringHelpers.sentenceJoin(attributes)
    }

    static getElements() {
        let elements = Store.getters.elements
        return elements
    }

    static getValueFromName(name) {
        let element =  this.getElements().find(o => o.name == name)
        return (element ? element.value || '' : '')
    }

    static getMasters(masterKey) {
        let masters = Store.getters.masters[masterKey]
        //let loanFields = LoanHelpers.loanFields()
        //got rid of loanfields as they are added to elements now when diagram is saved.

        if(!masters) // || !loanFields)   //store is empty on first load
            return []

        return [...masters] //, ...loanFields]
    }

    static uniqueName(originalName, existingNames) {
        existingNames = existingNames.filter(name => name)
        if(!originalName)
            return null
        let name = originalName.replace(/\s|-/g, '_').toLowerCase()
        let baseName = this.getBaseElementName(name)
        let n = 1
        while(existingNames.find(existingName => existingName == name)) {
            n++
            name = baseName + '_' + n
        }    
        return name  
    }

    static getBaseElementName(name) {
        if(!name)
            return null

        let nameArray = name.split('_')
        if(nameArray.length ==  1)
            return name

        let lastSegment = nameArray[nameArray.length - 1]
        if(!NumberHelpers.isNumeric(lastSegment))
            return name

        nameArray.splice(nameArray.length - 1, 1)
            return nameArray.join('_')
    }

    static contactElementsForRole(role, elements) {
        return elements.filter(o => o.role == role && o.type == 'Contact')
    }

    static fetchContactsForRole(transactionKey, role) {
        return new Promise( (resolve, reject) => {
            let ref = DataHelpers.getTransactionRef(transactionKey).child('elements').orderByChild('type').equalTo('Contact')
            NiceData.fetchItemsFromFirebase(ref).then(contactElements => {
                const filteredElements = contactElements.filter(o => o.role == role)
                const contacts = filteredElements.map(e => {
                    return {...e.contact, key: e.meta.key}
                })
                resolve(contacts)
            })
        })
    }

    static singleContactElementForRole(role, elements) {
        let contactElements = this.contactElementsForRole(role, elements)
        if(contactElements.length == 0)
            return null
        return contactElements[0]
    }

    static singleContactForRole(role, elements) {
        
        const el = this.singleContactElementForRole(role, elements)
        if(el)
            return {...el.contact, key:el.contactKey, uid:el.contactKey}
        else
            return null
    }

    static contactElementsUnique(elements) {
        let uniqueElements = []
        let contactElements = elements.filter(o => o.type == 'Contact')
        contactElements.forEach( (el) => {
            const existingIndex = uniqueElements.findIndex(o => o.contactKey == el.contactKey)
            if(existingIndex >= 0) {
                uniqueElements[existingIndex].roles.push(el.role)
            }
            else
                uniqueElements.push({...el, roles: [el.role]})
        })
        return uniqueElements
    }

    static filesForElement(element, elements) {

        let linkedFileKeys = element.linkedFileKeys || []

        //todo: old to remove...
        let fileElementsOld = elements.filter(o => (o.type == 'File' && o.triggerElementKey == element.key))
        fileElementsOld.forEach(file => {
            ArrayHelpers.pushUnique(file.key, linkedFileKeys)
        })

        let fileElements = elements.filter(element => element.type=='File' && linkedFileKeys.indexOf(element.key) > -1)
        
        return fileElements
    }

    static saveElement(element) {
        console.log('saveElement', element)
        Store.dispatch('saveElement', element)
    }

}


// WEBPACK FOOTER //
// ./src/helpers/ElementHelpers.js